import { Modal } from "@/shared/ui/Modal";

export const RandomQuoteModal = ({
  open,
  onOpenChange,
  quote,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  quote: { text: string; author: string } | null;
}) => {
  if (!quote) return null;

  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <Modal.Content>
        {quote && (
          <div className="text-center text-textColor">
            <strong className="text-center">{quote.text}</strong>
            <p className="text-right">{quote.author}</p>
          </div>
        )}
      </Modal.Content>
    </Modal>
  );
};
